import React, { useMemo } from 'react';
import { FixedSizeList } from 'react-window';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/system';
import MemberCard from './Cards/MemberCard.js';
import Text from './Text.js';
import { colors } from '../theme/index.js';
import i18n from '../localization/i18n.js';
import tokens from '../localization/tokens.js';
const MemberListHeader = styled(Grid)({
  backgroundColor: colors.surface,
  borderLeft: `${colors.surface} solid 5px`,
  boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
  cursor: 'pointer',
  height: 'auto',
  marginBottom: '0',
  minHeight: '70px',
  padding: '10px',
  position: 'relative',
  borderBottom: '2px solid rgba(0, 0, 0, 0.09)'
});

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const MemberList = ({
  employees,
  divisions,
  classesData,
  toggleNotificationModal,
  editEmployee,
  terminateEmployee,
  manageEmployee,
  isMasterSite
}) => {
  const itemData = useMemo(() => ({
    employees,
    divisions,
    classesData,
    toggleNotificationModal,
    editEmployee,
    terminateEmployee,
    manageEmployee,
    isMasterSite
  }), [employees, divisions, classesData, toggleNotificationModal, editEmployee, terminateEmployee, manageEmployee, isMasterSite]);

  /**
   * 
   * @param {*} param0 
   * @returns 
   */
  const Row = ({
    index,
    style
  }) => {
    const member = employees[index];
    return /*#__PURE__*/React.createElement("div", {
      style: style
    }, /*#__PURE__*/React.createElement(MemberCard, {
      key: member.userID,
      member: member,
      division: divisions[member.divisionID],
      class: classesData[member.classID],
      sendNotification: () => toggleNotificationModal(member.userID),
      onEditEmployee: () => editEmployee(member),
      terminateEmployee: () => terminateEmployee(member),
      onManageEmployee: () => manageEmployee(member),
      onClick: () => {
        window.location.href = isMasterSite ? `/members/${member.userID}` : `/member/${member.accountID}/${member.userID}`;
      }
    }));
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MemberListHeader, {
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2,
    sm: 2,
    md: 1
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4,
    sm: 4,
    md: 6
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true
  }, i18n.t(tokens.labels.classesAndDivisions.name))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 1,
    sm: 1,
    md: 1,
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    align: "center"
  }, i18n.t(tokens.titles.division))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2,
    sm: 2,
    md: 2,
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    align: "center"
  }, i18n.t(tokens.titles.class))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 1,
    sm: 1,
    md: 1,
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    align: "center"
  }, i18n.t(tokens.labels.claims.status))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2,
    sm: 1,
    md: 1,
    style: {
      textAlign: 'center'
    }
  })), /*#__PURE__*/React.createElement(FixedSizeList, {
    height: 800 // Total height for the list container
    ,
    width: "100%" // Width of the container
    ,
    itemSize: 68 // Height of each item (adjust based on MemberCard height)
    ,
    itemCount: employees.length // Total number of items
    ,
    itemData: itemData // Data passed to each row
  }, Row));
};
export default MemberList;